/* グリーンと鉢カバーの組み合わせシミュレーター
   単独のページ(index.html + products.js)と、Shopifyのセクション(sections/greenpot.liquid)の両方で動く。
   <div class="gp" data-greenpot> の中に画面を組み立てる。データは次のどちらかから読む:
     - 中の <script type="application/json" data-gp-data>(Shopify)
     - window.GREENPOT_DATA(単独のページ) */
(function () {
  'use strict';

  const NS = 'http://www.w3.org/2000/svg';
  const PLAIN_VIEW_CM = 260;  // 背景写真がないとき、画面の高さが何cm相当か
  const PHOTO_VIEW_CM = 250;  // 写真の背景の初期値
  const yen = (n) => '¥' + Math.round(n).toLocaleString('ja-JP');
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // 絞り込みの条件。範囲は「下限より大きく、上限以下」。いま該当する商品がない範囲も、ボタンは出しておく
  const FILTERS = {
    green: {
      height: [[0, 120, '〜120cm'], [120, 150, '121〜150cm'], [150, 180, '151〜180cm'], [180, Infinity, '181cm〜']],
      price: [[0, 20000, '〜2万円'], [20000, 30000, '2〜3万円'], [30000, 40000, '3〜4万円'], [40000, Infinity, '4万円〜']],
      multi: ['height'], // 複数の範囲を選べる条件(選んだ範囲のどれかに入れば出す)
      fit: '選んだ鉢カバーに入るものだけ',
      placeholder: '商品名で探す(例: ユーカリ)',
    },
    pot: {
      height: [[0, 30, '〜30cm'], [30, 40, '31〜40cm'], [40, Infinity, '41cm〜']],
      price: [
        [0, 8000, '〜8千円'], [8000, 10000, '8千〜1万円'], [10000, 12000, '1万〜1.2万円'], [12000, 15000, '1.2万〜1.5万円'],
        [15000, 20000, '1.5万〜2万円'], [20000, 30000, '2万〜3万円'], [30000, Infinity, '3万円〜'],
      ],
      multi: ['price'],
      fit: '選んだグリーンが入るものだけ',
      placeholder: '商品名で探す(例: WH)',
    },
  };

  // グリーン / 鉢カバーの欄(見出し・絞り込み・一覧)
  function productBlock(kind, en, ja) {
    const K = kind === 'green' ? 'Green' : 'Pot';
    return `<div>
      <div class="gp-headrow">
        <h3 class="gp-head"><span class="gp-en">${en}</span><span class="gp-ja">${ja}</span></h3>
        <div class="gp-headtools">
          <button type="button" class="gp-filter-btn" data-gp="${kind}FilterBtn" aria-expanded="false">絞り込む<span class="gp-fcount" hidden></span></button>
          <div class="gp-nav" data-gp-nav="${kind}List"><button type="button" class="gp-arrow" data-dir="-1" aria-label="前の${ja}を見る">‹</button><button type="button" class="gp-arrow" data-dir="1" aria-label="次の${ja}を見る">›</button></div>
        </div>
      </div>
      <span class="gp-picked" data-gp="picked${K}"></span>
      <div class="gp-filter" data-gp="${kind}Filter" hidden>
        <input type="search" data-f="q" placeholder="${FILTERS[kind].placeholder}" aria-label="${ja}を商品名で探す">
        <div class="gp-frow"><span class="gp-flbl">高さ</span><div class="gp-fchips" data-f="height"></div></div>
        <div class="gp-frow"><span class="gp-flbl">価格</span><div class="gp-fchips" data-f="price"></div></div>
        <label class="gp-check"><input type="checkbox" data-f="fit">${FILTERS[kind].fit}</label>
        <div class="gp-fstat"><span data-f="count"></span><button type="button" class="gp-link" data-f="clear">条件をクリア</button></div>
      </div>
      <div class="gp-cards gp-slide" data-gp="${kind}List"></div>
      <p class="gp-noresult" data-gp="${kind}NoResult" hidden>条件に合う${ja}がありません</p>
    </div>`;
  }

  function template(o) {
    return `
<div class="gp-layout">
  <section class="gp-media" aria-label="組み合わせのプレビュー">
    <div class="gp-stage" data-gp="stage">
      <div class="gp-bg" data-gp="bg"></div>
      <svg class="gp-overlay" data-gp="under"></svg>
      <span class="gp-chip" data-gp="chip" hidden></span>
      <div class="gp-empty" data-gp="empty" hidden>グリーンか鉢カバーを選んでください</div>
      <button type="button" class="gp-expand" data-gp="expand" aria-label="プレビューを大きく表示" aria-pressed="false">
        <svg class="gp-ico-open" viewBox="0 0 20 20" aria-hidden="true"><path d="M3 8V3h5M12 3h5v5M17 12v5h-5M8 17H3v-5"/></svg>
        <svg class="gp-ico-close" viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>
      </button>
    </div>
    <div class="gp-media-note">
      <span>プレビューをドラッグすると置く位置を動かせます</span><label class="gp-check"><input type="checkbox" data-gp="ruler" checked>目盛りを表示(10cmごと)</label>
      <div class="gp-size"><label>大きさ <input type="range" data-gp="scale" min="0.5" max="1.8" step="0.01" value="1"></label><button type="button" class="gp-link" data-gp="resetPlace">位置を戻す</button></div>
    </div>
  </section>
  <section class="gp-info">
    <div class="gp-title">
      <h2>${esc(o.title)}</h2>
      ${o.lead ? `<p>${esc(o.lead)}</p>` : ''}
    </div>
    ${productBlock('green', 'GREEN', 'グリーン')}
    ${productBlock('pot', 'POT', '鉢カバー')}
    <div>
      <h3 class="gp-head"><span class="gp-en">ROOM</span><span class="gp-ja">背景</span></h3>
      <div class="gp-cards" data-gp="bgList"></div>
      <input type="file" data-gp="bgFile" accept="image/*" hidden>
      <p class="gp-hint gp-room-hint">お部屋の写真を使うときは、置きたい場所までドラッグし、周りの家具と見比べてプレビュー下の「大きさ」を合わせてください。横長の写真は、プレビュー右上のボタンで大きく表示すると全体を見ながら置けます。写真はこの端末の中だけで使い、どこにも送りません。</p>
    </div>
    <div class="gp-fit" data-gp="fit" aria-live="polite" hidden></div>
    <div class="gp-summary" data-gp="summary">
      <div data-gp="rows" class="gp-rows"></div>
      <div class="gp-total"><span>合計</span><b data-gp="sum">¥0</b></div>
    </div>
    <div class="gp-actions">
      <button type="button" class="gp-btn gp-btn-primary" data-gp="addCart" disabled>まとめてカートに追加する</button>
      <button type="button" class="gp-btn gp-btn-outline" data-gp="copyUrl">この組み合わせのURLをコピー</button>
    </div>
    ${o.showTools === false ? '' : `
    <details class="gp-tools" data-gp="toolsBox">
      <summary>素材の確認用(スタッフ向け)</summary>
      <div class="gp-tools-body">
        <div>
          <h3>位置の微調整</h3>
          <div class="gp-adjust">
            <span>上下</span><input type="range" data-gp="adjY" min="-15" max="15" step="0.5" value="0"><output data-gp="adjYv">0cm</output>
            <span>左右</span><input type="range" data-gp="adjX" min="-15" max="15" step="0.5" value="0"><output data-gp="adjXv">0cm</output>
          </div>
          <p class="gp-hint">選んでいるグリーンごとに、このブラウザに保存されます。上下はプラスで深く沈みます。決まった値は商品の「左右の補正」「上下の補正」に入れてください。<br>決まった値: <code data-gp="adjOut">—</code></p>
        </div>
        <div>
          <h3>手元の透過素材で試す</h3>
          <div class="gp-drop" data-gp="drop" data-kind="green">
            <div class="gp-r">
              <button class="gp-btn gp-btn-outline gp-btn-sm" data-gp="pickFile" type="button">画像を選ぶ</button>
              <span class="gp-file" data-gp="fileName">PNG / WebP / SVG をここかプレビューにドラッグしても追加できます</span>
              <input type="file" data-gp="fileInput" accept="image/png,image/webp,image/svg+xml" hidden>
            </div>
            <div class="gp-r">
              <label>種類<select data-gp="kind"><option value="green">グリーン</option><option value="pot">鉢カバー</option></select></label>
              <label>名前<input type="text" data-gp="tName" placeholder="例: 210cmの樹木"></label>
            </div>
            <div class="gp-r">
              <label>商品の高さ(cm)<input type="number" data-gp="tHeight" step="0.1" min="1" placeholder="210"></label>
              <label class="gp-green-only">内鉢の径(cm)<input type="number" data-gp="tNurseryW" step="0.1" placeholder="15.5"></label>
              <label class="gp-pot-only">口径(cm)<input type="number" data-gp="tMouth" step="0.1" placeholder="26"></label>
              <label class="gp-pot-only">内底の径(cm)<input type="number" data-gp="tBottom" step="0.1" placeholder="17"></label>
            </div>
            <div class="gp-r"><label>価格(任意)<input type="number" data-gp="tPrice" step="1" placeholder="0"></label></div>
            <div><button class="gp-btn gp-btn-primary gp-btn-sm" data-gp="addBtn" type="button" disabled>一覧に追加</button></div>
            <p class="gp-hint" style="margin:0">鉢カバーは真横から撮影した1枚を使います。追加したものは再読み込みすると消えます。</p>
          </div>
        </div>
      </div>
    </details>`}
  </section>
</div>
<div class="gp-toast" data-gp="toast" role="status"></div>`;
  }

  function mount(root) {
    const jsonEl = root.querySelector('script[data-gp-data]');
    const data = jsonEl ? JSON.parse(jsonEl.textContent) : window.GREENPOT_DATA;
    if (!data) { root.textContent = '商品データが読み込めません'; return; }
    const o = Object.assign({ title: 'グリーンと鉢カバーの組み合わせ', lead: '', showTools: true, cart: null }, data.options || {});
    root.insertAdjacentHTML('beforeend', template(o));
    const $ = (name) => root.querySelector(`[data-gp="${name}"]`);

    // ---- 状態 ----
    const state = {
      greens: (data.greens || []).slice(), pots: (data.pots || []).slice(),
      backgrounds: (data.backgrounds || []).slice(),
      greenId: null, potId: null, bgId: null,
      adjust: loadStore('greenpot-adjust'),
      place: {},
      filter: { green: newFilter(), pot: newFilter() },
    };
    function newFilter() { return { q: '', height: [], price: [], fit: false }; } // height / price は選んだ範囲の番号
    const imgCache = new Map();

    // ---- 画像の読み込みと解析 ----
    function loadImage(src) {
      if (imgCache.has(src)) return imgCache.get(src).promise;
      const entry = {};
      entry.promise = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          entry.img = img; entry.w = img.naturalWidth || 1; entry.h = img.naturalHeight || 1;
          try { entry.analysis = analyze(img); } catch { entry.analysis = null; } // 別ドメインの画像やfile://では解析できないことがある → 数値から計算
          resolve(entry);
        };
        img.onerror = () => reject(new Error('画像を読み込めません: ' + src));
        img.src = src;
      });
      imgCache.set(src, entry);
      return entry.promise;
    }

    // 透過部分から各行の不透明な範囲を調べ、内鉢の幅と幹の中心を求める
    function analyze(img) {
      const H = Math.min(800, img.naturalHeight || 800);
      const W = Math.max(1, Math.round((img.naturalWidth / img.naturalHeight) * H));
      const c = document.createElement('canvas'); c.width = W; c.height = H;
      const ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      const px = ctx.getImageData(0, 0, W, H).data;
      const rows = new Array(H);
      let top = -1, bottom = -1, maxW = 0, maxRowCenter = 0.5;
      for (let y = 0; y < H; y++) {
        let minX = -1, maxX = -1;
        for (let x = 0; x < W; x++) if (px[(y * W + x) * 4 + 3] > 40) { if (minX < 0) minX = x; maxX = x; }
        rows[y] = minX < 0 ? null : [minX, maxX];
        if (minX >= 0) {
          if (top < 0) top = y; bottom = y;
          if (maxX - minX > maxW) { maxW = maxX - minX; maxRowCenter = (minX + maxX) / 2 / W; }
        }
      }
      if (top < 0) return null;
      const span = (y) => (rows[y] ? rows[y][1] - rows[y][0] : 0);
      // 内鉢の幅: 下端は底の丸みで細くなるので、下から4%の範囲でいちばん広い行を使う
      let baseW = 0, baseRow = rows[bottom];
      for (let y = bottom; y > bottom - Math.max(4, H * 0.04) && y >= 0; y--) if (span(y) > baseW) { baseW = span(y); baseRow = rows[y]; }
      return { top: top / H, bottom: (bottom + 1) / H, baseCenterX: (baseRow[0] + baseRow[1]) / 2 / W, baseWidthRatio: baseW / H, centerX: maxRowCenter };
    }

    const findGreen = () => state.greens.find((g) => g.id === state.greenId) || null;
    const findPot = () => state.pots.find((p) => p.id === state.potId) || null;
    const findBg = () => state.backgrounds.find((b) => b.id === state.bgId) || null;

    function greenGeometry(g) {
      const a = imgCache.get(g.image)?.analysis;
      return { centerX: a?.baseCenterX ?? 0.5, detectedNurseryW: a ? a.baseWidthRatio * g.heightCm : null };
    }
    function potGeometry(p) {
      const a = imgCache.get(p.imageFront)?.analysis;
      return { centerX: a?.centerX ?? 0.5, bottomCm: 3 }; // 内鉢は鉢カバーの内底に置く。底の厚みは3cm固定
    }

    // ---- 共有URL: #グリーン~鉢~背景(空=最初の候補、0=外す) ----
    const tok = (id, local) => (id == null ? '0' : local ? '' : encodeURIComponent(id));
    const shareToken = () => [tok(state.greenId, findGreen()?.local), tok(state.potId, findPot()?.local), tok(state.bgId, findBg()?.local)].join('~');
    function readToken() {
      const m = decodeURIComponent(location.hash.slice(1)).match(/^([^~]*)~([^~]*)(?:~([^~]*))?$/);
      if (!m) return null;
      const v = (s) => (s === undefined || s === '' ? undefined : s === '0' ? null : s);
      return { green: v(m[1]), pot: v(m[2]), bg: v(m[3]) };
    }
    function syncUrl() { try { history.replaceState(history.state, '', location.pathname + location.search + '#' + shareToken()); } catch { /* 書き換えられなくても動作は続ける */ } }

    // ---- 一覧 ----
    function card({ pressed, cls = '', ph, name, price, badge, onClick, onDelete }) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'gp-card ' + cls;
      b.setAttribute('aria-pressed', String(!!pressed));
      b.innerHTML = `<div class="gp-ph">${ph}</div><div class="gp-nm"></div>${price != null ? '<div class="gp-pr"></div>' : ''}`;
      b.querySelector('.gp-nm').textContent = name;
      if (price != null) b.querySelector('.gp-pr').textContent = price;
      if (badge) { const s = document.createElement('span'); s.className = 'gp-badge ' + (badge.cls || ''); s.textContent = badge.text; b.appendChild(s); }
      if (onDelete) {
        const d = document.createElement('span');
        d.className = 'gp-del'; d.textContent = '×'; d.title = '一覧から削除'; d.setAttribute('role', 'button');
        d.onclick = (e) => { e.stopPropagation(); onDelete(); };
        b.appendChild(d);
      }
      b.onclick = onClick;
      return b;
    }

    function renderProductList(el, items, kind) {
      const keep = el.scrollLeft; // 選び直すたびに作り直すので、横の位置を戻す
      el.innerHTML = '';
      const selected = kind === 'green' ? state.greenId : state.potId;
      el.appendChild(card({ pressed: selected == null, cls: 'is-none', ph: '外す', name: kind === 'green' ? 'グリーンなし' : '鉢カバーなし', price: '', onClick: () => select(kind, null) }));
      const shown = items.filter((it) => matches(kind, it));
      renderFilterUi(kind, items, shown.length);
      for (const it of shown) {
        const ph = kind === 'green' ? `<img src="${esc(it.image)}" alt="" loading="lazy">`
          : `<img src="${esc(it.imageFront)}" alt="" loading="lazy">`;
        const badge = it.local ? { text: '追加' } : it.available === false ? { text: '在庫切れ' } : (it.provisional?.length ? { text: '仮', cls: 'is-light' } : null);
        el.appendChild(card({
          pressed: selected === it.id, cls: it.available === false ? 'is-soldout' : '', ph, name: it.title, price: it.price ? yen(it.price) : '—', badge,
          onClick: () => select(kind, selected === it.id ? null : it.id), // 選択中をもう一度押すと外す
          onDelete: it.local ? () => removeLocal(kind, it.id) : null,
        }));
      }
      el.scrollLeft = keep;
      updateNav(el);
    }

    // ---- 絞り込み ----
    const norm = (s) => String(s ?? '').normalize('NFKC').toLowerCase();
    const inRange = (v, r) => v > r[0] && v <= r[1];
    // 内鉢の幅か口径が分からないときは判定できないので、入るものとして扱う
    function fits(g, p) {
      const nW = g.nurseryWcm ?? greenGeometry(g).detectedNurseryW;
      return !nW || !p.mouthCm || nW <= p.mouthCm;
    }
    function matches(kind, it) {
      const f = state.filter[kind], cfg = FILTERS[kind];
      if (f.q) {
        const t = norm(it.title);
        if (!norm(f.q).split(/\s+/).filter(Boolean).every((w) => t.includes(w))) return false;
      }
      if (f.height.length && !f.height.some((i) => inRange(it.heightCm, cfg.height[i]))) return false;
      if (f.price.length && !f.price.some((i) => inRange(it.price || 0, cfg.price[i]))) return false;
      if (f.fit) {
        const other = kind === 'green' ? findPot() : findGreen();
        if (other && !(kind === 'green' ? fits(it, other) : fits(other, it))) return false;
      }
      return true;
    }
    function renderFilterUi(kind, items, count) {
      const f = state.filter[kind], cfg = FILTERS[kind], box = $(kind + 'Filter');
      for (const key of ['height', 'price']) {
        const wrap = box.querySelector(`[data-f="${key}"]`);
        wrap.innerHTML = '';
        cfg[key].forEach((r, i) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'gp-fchip'; b.textContent = r[2];
          const on = f[key].includes(i);
          b.setAttribute('aria-pressed', String(on));
          b.onclick = () => { // もう一度押すと外す
            f[key] = on ? f[key].filter((x) => x !== i) : cfg.multi.includes(key) ? [...f[key], i] : [i];
            refreshList(kind);
          };
          wrap.appendChild(b);
        });
      }
      box.querySelector('[data-f="fit"]').checked = f.fit;
      box.querySelector('[data-f="count"]').textContent = `${items.length}件中 ${count}件を表示`;
      const n = (f.q.trim() ? 1 : 0) + (f.height.length ? 1 : 0) + (f.price.length ? 1 : 0) + (f.fit ? 1 : 0);
      const badge = $(kind + 'FilterBtn').querySelector('.gp-fcount');
      badge.textContent = n; badge.hidden = !n;
      $(kind + 'NoResult').hidden = count > 0;
    }
    function refreshList(kind) {
      const el = $(kind + 'List');
      renderProductList(el, kind === 'green' ? state.greens : state.pots, kind);
      el.scrollLeft = 0; updateNav(el); // 条件を変えたら先頭から見せる
    }
    function bindFilter(kind) {
      const btn = $(kind + 'FilterBtn'), box = $(kind + 'Filter'), f = state.filter[kind];
      btn.setAttribute('aria-controls', box.id = `gp-${kind}-filter-${Math.random().toString(36).slice(2, 8)}`);
      btn.onclick = () => { box.hidden = !box.hidden; btn.setAttribute('aria-expanded', String(!box.hidden)); if (!box.hidden) box.querySelector('[data-f="q"]').focus(); };
      const q = box.querySelector('[data-f="q"]');
      q.addEventListener('input', () => { f.q = q.value; refreshList(kind); });
      box.querySelector('[data-f="fit"]').onchange = (e) => { f.fit = e.target.checked; refreshList(kind); };
      box.querySelector('[data-f="clear"]').onclick = () => { Object.assign(f, newFilter()); q.value = ''; refreshList(kind); };
    }

    // ---- 商品一覧のスライダー(2段で横に並べ、矢印か横スクロールで送る) ----
    function updateNav(el) {
      const nav = root.querySelector(`[data-gp-nav="${el.dataset.gp}"]`);
      if (!nav) return;
      const max = el.scrollWidth - el.clientWidth;
      nav.hidden = max <= 1; // 全部見えているときは矢印を出さない
      const [prev, next] = nav.querySelectorAll('.gp-arrow');
      prev.disabled = el.scrollLeft <= 1;
      next.disabled = el.scrollLeft >= max - 1;
    }
    function bindSlider(key) {
      const el = $(key);
      root.querySelectorAll(`[data-gp-nav="${key}"] .gp-arrow`).forEach((b) => {
        b.onclick = () => el.scrollBy({ left: Number(b.dataset.dir) * el.clientWidth * 0.9, behavior: 'smooth' });
      });
      el.addEventListener('scroll', () => updateNav(el), { passive: true });
      new ResizeObserver(() => updateNav(el)).observe(el);
    }
    function scrollToPressed(el) {
      // URLで組み合わせを開いたとき、選ばれている商品が見える位置まで送る
      const c = el.querySelector('.gp-card[aria-pressed="true"]');
      if (c && c.offsetLeft + c.offsetWidth > el.clientWidth) el.scrollLeft = c.offsetLeft;
    }

    function renderPicked(el, it) {
      // 見出しの下の商品名は、商品ページへのリンクにする
      const a = document.createElement(it?.url ? 'a' : 'span');
      a.className = 'gp-picked'; a.textContent = it ? it.title : '選択なし';
      if (it?.url) { a.href = it.url; a.title = '商品ページを見る'; }
      el.replaceWith(a); a.setAttribute('data-gp', el.getAttribute('data-gp'));
    }

    function renderBgList() {
      const el = $('bgList');
      el.innerHTML = '';
      for (const b of state.backgrounds) {
        const ph = `<img src="${esc(b.image)}" alt="" loading="lazy">`;
        const c = card({ pressed: state.bgId === b.id, ph, name: b.title, badge: b.local ? { text: '写真' } : null, onClick: () => selectBg(b.id), onDelete: b.local ? () => removeBg(b.id) : null });
        c.querySelector('.gp-ph').classList.add('gp-full');
        el.appendChild(c);
      }
      el.appendChild(card({ cls: 'is-add', ph: '+', name: 'お部屋の写真を使う', onClick: () => $('bgFile').click() }));
    }

    function renderLists() {
      renderProductList($('greenList'), state.greens, 'green');
      renderProductList($('potList'), state.pots, 'pot');
      renderBgList();
      renderPicked($('pickedGreen'), findGreen());
      renderPicked($('pickedPot'), findPot());
    }

    function select(kind, id) { if (kind === 'green') state.greenId = id; else state.potId = id; renderLists(); render(); syncUrl(); }
    function selectBg(id) { state.bgId = id; renderBgList(); render(); syncUrl(); }

    // ---- 置き場所 ----
    function currentPlace() {
      const b = findBg(); const key = b?.id ?? 'none';
      if (!state.place[key]) state.place[key] = { x: b?.x ?? 0.5, floorY: b?.floorY ?? 0.9, scale: 1 };
      return state.place[key];
    }
    function viewCm() {
      const b = findBg();
      const base = !b ? PLAIN_VIEW_CM : (b.viewCm || PHOTO_VIEW_CM);
      return base / currentPlace().scale;
    }

    // ---- 合成 ----
    let last = null;
    function render() {
      const stage = $('stage');
      stage.querySelectorAll('.gp-layer').forEach((n) => n.remove());
      const under = $('under'); under.innerHTML = '';
      const g = findGreen(), p = findPot(), b = findBg();
      $('empty').hidden = !!(g || p);
      const W = stage.clientWidth, H = stage.clientHeight;
      if (!W || !H) return;
      const place = currentPlace();

      const bgLayer = $('bg');
      if (!b) {
        bgLayer.innerHTML = ''; bgLayer.dataset.src = '';
      } else if (bgLayer.dataset.src !== b.image) {
        bgLayer.innerHTML = `<img src="${esc(b.image)}" alt="" draggable="false">`; bgLayer.dataset.src = b.image;
        const im = bgLayer.querySelector('img');
        im.onload = () => { if (expanded) fitExpanded(); render(); }; // 写真の縦横比が分かってから置き直す
      }
      // 商品の位置と大きさは、写真全体(枠からはみ出して見えていない部分も含む)を基準にする。
      // こうしておくと、枠の縦横比が変わっても(拡大表示など)写真の中の同じ場所・同じ大きさに置かれる
      const bgImg = bgLayer.querySelector('img');
      const box = { left: 0, top: 0, w: W, h: H };
      if (bgImg?.naturalWidth) {
        const c = Math.max(W / bgImg.naturalWidth, H / bgImg.naturalHeight); // object-fit: cover と同じ
        box.w = bgImg.naturalWidth * c; box.h = bgImg.naturalHeight * c;
        box.left = (W - box.w) / 2; box.top = (H - box.h) / 2;
      }
      const s = box.h / viewCm();
      const cx = box.left + place.x * box.w, floorY = box.top + place.floorY * box.h;

      // 高さの目安の目盛り(お客さんがチェックボックスで切り替える)。背景写真の上でも読めるよう、写真のときは白い縁取りを付ける
      if ($('ruler').checked) drawRuler(under, floorY, s, !!b);

      const layers = [];
      let topMost = floorY, potBox = null;
      if (p) {
        const e = imgCache.get(p.imageFront);
        if (e?.img) {
          const geo = potGeometry(p);
          const h = p.heightCm * s, w = h * (e.w / e.h);
          const left = cx - geo.centerX * w, top = floorY - h;
          potBox = { geo };
          layers.push([p.imageFront, left, top, w, h, 4]);
          topMost = Math.min(topMost, top);
          shadow(under, cx, floorY, w * 0.55, Math.max(3, w * 0.07));
        }
      }
      if (g) {
        const e = imgCache.get(g.image);
        if (e?.img) {
          const geo = greenGeometry(g);
          const adj = state.adjust[g.id] || { x: g.offsetXcm || 0, y: g.offsetYcm || 0 };
          const h = g.heightCm * s, w = h * (e.w / e.h);
          let left, top;
          if (potBox) {
            // 内鉢の底を鉢カバーの内底(床から底の厚み分の高さ)に合わせる
            left = cx - geo.centerX * w + adj.x * s;
            top = floorY - potBox.geo.bottomCm * s - h + adj.y * s;
          } else {
            left = cx - geo.centerX * w; top = floorY - h;
            shadow(under, cx, floorY, Math.max(14, (g.nurseryWcm ?? geo.detectedNurseryW ?? 18) * s * 0.7), 4);
          }
          layers.push([g.image, left, top, w, h, 2]);
          topMost = Math.min(topMost, top);
        }
      }
      for (const [src, left, top, w, h, z] of layers) {
        const img = document.createElement('img');
        img.className = 'gp-layer'; img.src = src; img.alt = '';
        Object.assign(img.style, { left: left + 'px', top: top + 'px', width: w + 'px', height: h + 'px', zIndex: z });
        stage.appendChild(img);
      }
      const chip = $('chip');
      chip.hidden = !(g || p);
      chip.textContent = `設置したときの高さ 約${Math.round((floorY - topMost) / s)}cm`;
      $('scale').value = place.scale;
      last = { W, H, box };
      renderFit(g, p); renderTotal(g, p); renderAdjust(g);
    }

    function drawRuler(svg, floorY, s, onPhoto) {
      const ink = onPhoto ? 'rgba(18,18,18,.85)' : 'rgba(18,18,18,.45)';
      const halo = 'rgba(255,255,255,.85)';
      const x = 26;
      const line = (x1, y1, x2, y2, w) => {
        // 写真の上では、先に太い白線を引いてから目盛りを重ねる
        for (const [stroke, sw] of onPhoto ? [[halo, w + 2.5], [ink, w]] : [[ink, w]]) {
          const l = document.createElementNS(NS, 'line'); Object.entries({ x1, y1, x2, y2, stroke, 'stroke-width': sw, 'stroke-linecap': 'round' }).forEach(([k, v]) => l.setAttribute(k, v)); svg.appendChild(l);
        }
      };
      let maxCm = 0;
      for (let cm = 0; floorY - cm * s > 8; cm += 10) {
        const y = floorY - cm * s, major = cm % 50 === 0;
        line(x - (major ? 10 : 5), y, x, y, major ? 1.1 : 0.8);
        if (major && cm > 0) {
          const t = document.createElementNS(NS, 'text');
          Object.entries({ x: 4, y: y + 3.5, 'font-size': 9.5, fill: ink, ...(onPhoto ? { stroke: halo, 'stroke-width': 2.5, 'paint-order': 'stroke' } : {}) }).forEach(([k, v]) => t.setAttribute(k, v));
          t.textContent = cm; svg.appendChild(t);
        }
        maxCm = cm;
      }
      line(x, floorY, x, floorY - maxCm * s, 0.8);
    }
    function shadow(svg, cx, cy, rx, ry) {
      const e = document.createElementNS(NS, 'ellipse');
      Object.entries({ cx, cy, rx, ry, fill: 'rgba(0,0,0,.2)' }).forEach(([k, v]) => e.setAttribute(k, v));
      e.style.filter = 'blur(3px)';
      svg.appendChild(e);
    }

    // ---- サイズの相性 ----
    function renderFit(g, p) {
      const el = $('fit');
      if (!g || !p) { el.hidden = true; return; }
      const geo = greenGeometry(g);
      const nW = g.nurseryWcm ?? geo.detectedNurseryW;
      if (!p.mouthCm || !nW) { el.hidden = true; return; } // 寸法が分からないときは判定しない
      const est = g.nurseryWcm ? '' : '(画像から推定)';
      const cm = (v) => `${Number.isInteger(v) ? v : v.toFixed(1)}cm`;
      const ok = nW <= p.mouthCm;
      const view = ok
        ? { title: 'この鉢カバーに入ります', msg: 'グリーンの内鉢が、鉢カバーの口の中に収まります。' }
        : { title: 'この鉢カバーには入りません', msg: `内鉢が鉢カバーの口より約${cm(Math.ceil((nW - p.mouthCm) * 10) / 10)}大きいため、入りません。別の鉢カバーを選んでください。` };
      const gap = p.mouthCm - nW;
      const num = (v) => (Number.isInteger(v) ? v : v.toFixed(1));
      el.className = 'gp-fit ' + (ok ? 'is-ok' : 'is-ng');
      // 内鉢の幅と口径を「17cm < 25cm」の形で並べ、どちらが大きいかを記号で見せる
      el.innerHTML = `
        <h3 class="gp-head"><span class="gp-en">SIZE CHECK</span><span class="gp-ja">サイズの判定</span></h3>
        <p class="gp-fit-result"><span class="gp-fit-dot" aria-hidden="true"></span>${view.title}</p>
        <dl class="gp-fit-vals">
          <div><dt>グリーンの内鉢の幅${est ? `<small>${est}</small>` : ''}</dt><dd>${num(Math.round(nW * 10) / 10)}<span>cm</span></dd></div>
          <div class="gp-fit-op" aria-hidden="true">${nW === p.mouthCm ? '=' : ok ? '&lt;' : '&gt;'}</div>
          <div><dt>鉢カバーの口径</dt><dd>${num(p.mouthCm)}<span>cm</span></dd></div>
        </dl>
        <p class="gp-fit-msg">${esc(view.msg)}${ok && gap > 8 ? `<br>すき間が約${Math.round(gap)}cmあるので、マルチング(土の表面を覆う資材)で隠すのがおすすめです。` : ''}</p>`;
      el.hidden = false;
    }

    // ---- 合計とカート ----
    function renderTotal(g, p) {
      const rows = $('rows'); rows.innerHTML = '';
      let sum = 0;
      for (const [label, it] of [['グリーン', g], ['鉢カバー', p]]) {
        if (!it) continue;
        sum += it.price || 0;
        const d = document.createElement('div'); d.className = 'gp-row';
        const left = document.createElement('span');
        const lbl = document.createElement('span'); lbl.className = 'gp-lbl'; lbl.textContent = label;
        const name = document.createElement('span'); name.className = 'gp-name'; name.textContent = it.title;
        left.append(lbl, name);
        if (it.url) { const a = document.createElement('a'); a.className = 'gp-go'; a.href = it.url; a.textContent = '商品ページを見る ›'; left.append(a); }
        const right = document.createElement('span');
        const price = document.createElement('span'); price.className = 'gp-yen'; price.textContent = it.price ? yen(it.price) : '—';
        right.append(price);
        if (it.available === false) { const so = document.createElement('span'); so.className = 'gp-soldout'; so.textContent = '在庫切れ'; right.append(so); }
        d.append(left, right); rows.appendChild(d);
      }
      $('summary').hidden = !(g || p);
      $('sum').textContent = yen(sum);
      $('addCart').disabled = !cartItems().length;
      const soldOut = [g, p].some((it) => it && it.available === false);
      $('addCart').textContent = soldOut ? '在庫のある商品だけカートに追加する' : 'まとめてカートに追加する';
    }
    const cartItems = () => [findGreen(), findPot()].filter((it) => it?.variantId && it.available !== false).map((it) => ({ id: it.variantId, quantity: 1 }));

    async function addToCart() {
      const items = cartItems();
      if (!items.length) return;
      if (!o.cart) { toast('試作なのでカートには追加していません。\nストアに組み込むと、選んだ商品をまとめてカートに追加します。'); return; }
      const r = await fetch(o.cart.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (r.ok) { location.href = o.cart.cartUrl; return; }
      let msg = ''; try { msg = (await r.json()).description || ''; } catch { /* 本文なし */ }
      toast('カートに追加できませんでした' + (msg ? ':\n' + msg : '(' + r.status + ')'));
    }

    // ---- 微調整 ----
    function loadStore(key) { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } }
    function saveAdjust() { try { localStorage.setItem('greenpot-adjust', JSON.stringify(state.adjust)); } catch { /* 保存できなくても動作は続ける */ } }
    function renderAdjust(g) {
      if (!$('adjX')) return;
      const a = (g && state.adjust[g.id]) || { x: g?.offsetXcm || 0, y: g?.offsetYcm || 0 };
      $('adjX').value = a.x; $('adjY').value = a.y;
      $('adjX').disabled = $('adjY').disabled = !g;
      $('adjXv').textContent = a.x + 'cm'; $('adjYv').textContent = a.y + 'cm';
      $('adjOut').textContent = g ? `左右 ${a.x} / 上下 ${a.y}` : '—';
    }

    // ---- 手元の素材を追加 ----
    let pendingFile = null;
    function setFile(file) {
      if (!file || !/^image\/(png|webp|svg\+xml)$/.test(file.type)) { toast('透過PNG・WebP・SVGの画像を選んでください'); return; }
      pendingFile = file;
      $('fileName').textContent = file.name;
      if (!$('tName').value) $('tName').value = file.name.replace(/\.[^.]+$/, '');
      $('addBtn').disabled = false;
    }
    async function addLocal() {
      if (!pendingFile) return;
      const kind = $('kind').value;
      const heightCm = parseFloat($('tHeight').value);
      if (!(heightCm > 0)) { toast('商品の高さ(cm)を入れてください'); return; }
      const url = URL.createObjectURL(pendingFile);
      const num = (n) => { const v = parseFloat($(n).value); return v > 0 ? v : undefined; };
      const base = { id: 'local-' + Date.now(), title: $('tName').value || pendingFile.name, price: num('tPrice') || 0, heightCm, local: true };
      try { await loadImage(url); } catch { toast('画像を読み込めませんでした'); return; }
      const a = imgCache.get(url).analysis;
      if (a && (a.top > 0.02 || a.bottom < 0.98)) toast('画像の上下に余白があります。上端〜下端がちょうど「商品の高さ」になるように切り抜くと正確になります');
      if (kind === 'green') { state.greens.push({ ...base, image: url, nurseryWcm: num('tNurseryW') }); state.greenId = base.id; }
      else { state.pots.push({ ...base, imageFront: url, mouthCm: num('tMouth'), innerBottomCm: num('tBottom') }); state.potId = base.id; }
      pendingFile = null; $('fileName').textContent = '続けて追加できます'; $('addBtn').disabled = true;
      for (const n of ['tName', 'tHeight', 'tNurseryW','tMouth', 'tBottom', 'tPrice']) $(n).value = '';
      renderLists(); render(); syncUrl();
    }
    function removeLocal(kind, id) {
      const list = kind === 'green' ? state.greens : state.pots;
      const i = list.findIndex((x) => x.id === id);
      if (i >= 0) list.splice(i, 1);
      if (kind === 'green' && state.greenId === id) state.greenId = null;
      if (kind === 'pot' && state.potId === id) state.potId = null;
      renderLists(); render(); syncUrl();
    }

    // ---- 背景写真 ----
    function addBgPhoto(file) {
      if (!file || !/^image\//.test(file.type)) { toast('画像ファイルを選んでください'); return; }
      const id = 'photo-' + Date.now();
      state.backgrounds.push({ id, title: file.name.replace(/\.[^.]+$/, ''), type: 'photo', image: URL.createObjectURL(file), local: true });
      selectBg(id);
      toast('置きたい場所までドラッグし、プレビュー下の「大きさ」で周りの家具と合わせてください。右上のボタンで大きく表示すると写真全体が見えます');
    }
    function removeBg(id) {
      const i = state.backgrounds.findIndex((b) => b.id === id);
      if (i >= 0) state.backgrounds.splice(i, 1);
      if (state.bgId === id) state.bgId = state.backgrounds[0]?.id ?? null;
      renderBgList(); render(); syncUrl();
    }

    // ---- 画面操作 ----
    let toastTimer;
    function toast(msg) {
      const t = $('toast'); t.textContent = msg; t.classList.add('is-show');
      clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-show'), 5000);
    }

    // ---- 拡大表示 ----
    // プレビューを画面いっぱいに出す。背景写真があるときは、写真の縦横比のまま全体が見える大きさにする(横長のお部屋の写真向け)
    let expanded = false;
    function fitExpanded() {
      const stage = $('stage'), note = root.querySelector('.gp-media-note');
      const img = $('bg').querySelector('img');
      const ratio = img?.naturalWidth ? img.naturalWidth / img.naturalHeight : 4 / 5;
      const aw = window.innerWidth - 32, ah = window.innerHeight - 32 - note.offsetHeight - 10;
      const w = Math.min(aw, ah * ratio);
      stage.style.width = note.style.width = Math.floor(w) + 'px';
      stage.style.height = Math.floor(w / ratio) + 'px';
    }
    function setExpanded(on) {
      expanded = on;
      const stage = $('stage'), note = root.querySelector('.gp-media-note'), btn = $('expand');
      root.querySelector('.gp-media').classList.toggle('is-expanded', on);
      document.documentElement.style.overflow = on ? 'hidden' : ''; // 後ろのページがスクロールしないようにする
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? '拡大表示を閉じる' : 'プレビューを大きく表示');
      if (on) fitExpanded(); else stage.style.width = stage.style.height = note.style.width = '';
      render();
      btn.focus();
    }

    function bindUi() {
      const stage = $('stage');
      let drag = null;
      $('expand').onclick = () => setExpanded(!expanded);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && expanded) setExpanded(false); });
      window.addEventListener('resize', () => { if (expanded) fitExpanded(); });
      stage.addEventListener('pointerdown', (e) => {
        if (e.button !== 0 || e.target.closest('.gp-expand')) return; // 拡大表示のボタンではドラッグを始めない
        const pl = currentPlace();
        drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x: pl.x, y: pl.floorY };
        try { stage.setPointerCapture(e.pointerId); } catch { /* 捕捉できなくてもドラッグは続ける */ }
        stage.classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', (e) => {
        if (!drag || e.pointerId !== drag.id || !last) return;
        // 動かせる範囲は、今の枠に見えているところ(左右は枠の5%内側、下は枠の99%まで)。
        // 横長の写真で枠の外に切れている部分には置けないので、端に置きたいときは拡大表示で写真全体を出して動かす
        const pl = currentPlace(), { W, H, box } = last;
        const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
        pl.x = clamp(drag.x + (e.clientX - drag.sx) / box.w, (W * 0.05 - box.left) / box.w, (W * 0.95 - box.left) / box.w);
        pl.floorY = clamp(drag.y + (e.clientY - drag.sy) / box.h, (H * 0.3 - box.top) / box.h, (H * 0.99 - box.top) / box.h);
        render();
      });
      // 背景写真などの画像をブラウザが「画像のドラッグ」として持っていくと、置く位置のドラッグが数pxで止まるので止める
      stage.addEventListener('dragstart', (e) => e.preventDefault());
      const end = () => { drag = null; stage.classList.remove('is-dragging'); };
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);

      $('addCart').onclick = () => addToCart().catch((e) => toast('エラー: ' + e.message));
      $('copyUrl').onclick = async () => {
        const url = location.href.split('#')[0] + '#' + shareToken();
        const local = [findGreen(), findPot(), findBg()].some((x) => x?.local);
        try { await navigator.clipboard.writeText(url); toast(local ? 'URLをコピーしました(手元で追加した画像や写真はURLでは共有されません)' : 'URLをコピーしました'); }
        catch { toast('コピーできませんでした:\n' + url); }
      };
      $('scale').oninput = () => { currentPlace().scale = parseFloat($('scale').value); render(); };
      $('ruler').onchange = () => render();
      $('resetPlace').onclick = () => { delete state.place[findBg()?.id ?? 'none']; render(); };
      $('bgFile').onchange = () => { addBgPhoto($('bgFile').files[0]); $('bgFile').value = ''; };
      stage.addEventListener('dragover', (e) => e.preventDefault());
      stage.addEventListener('drop', (e) => {
        e.preventDefault();
        const f = e.dataTransfer.files[0]; if (!f) return;
        if (/^image\/(png|webp|svg\+xml)$/.test(f.type) && $('drop')) { $('toolsBox').open = true; setFile(f); $('drop').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else addBgPhoto(f);
      });

      if (!$('drop')) return; // スタッフ向けの欄を出さない設定
      for (const [n, key] of [['adjX', 'x'], ['adjY', 'y']]) {
        $(n).oninput = () => {
          const g = findGreen(); if (!g) return;
          const a = state.adjust[g.id] || { x: g.offsetXcm || 0, y: g.offsetYcm || 0 };
          a[key] = parseFloat($(n).value);
          state.adjust[g.id] = a; saveAdjust(); render();
        };
      }
      $('kind').onchange = () => { $('drop').dataset.kind = $('kind').value; };
      $('pickFile').onclick = () => $('fileInput').click();
      $('fileInput').onchange = () => { setFile($('fileInput').files[0]); $('fileInput').value = ''; };
      $('addBtn').onclick = () => addLocal();
      const drop = $('drop');
      drop.addEventListener('dragover', (e) => { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', () => drop.classList.remove('is-over'));
      drop.addEventListener('drop', (e) => { e.preventDefault(); drop.classList.remove('is-over'); setFile(e.dataTransfer.files[0]); });
    }

    // ---- 開始 ----
    const t = readToken();
    const pick = (want, list) => (want === undefined ? list[0]?.id ?? null : want === null ? null : list.some((x) => x.id === want) ? want : list[0]?.id ?? null);
    state.greenId = pick(t?.green, state.greens);
    state.potId = pick(t?.pot, state.pots);
    state.bgId = pick(t?.bg, state.backgrounds);
    Promise.allSettled([
      ...state.greens.map((g) => loadImage(g.image)),
      ...state.pots.map((p) => loadImage(p.imageFront)),
    ]).then(() => {
      renderLists(); render(); bindUi();
      for (const kind of ['green', 'pot']) { bindSlider(kind + 'List'); bindFilter(kind); scrollToPressed($(kind + 'List')); }
      new ResizeObserver(() => render()).observe($('stage'));
      root.greenpot = { state, greenGeometry, render }; // 確認用
    });
  }

  function boot() { document.querySelectorAll('[data-greenpot]').forEach((root) => { if (!root.dataset.gpMounted) { root.dataset.gpMounted = '1'; mount(root); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot); // テーマのカスタマイズ画面で編集したとき
})();
